"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateCompanyDto = exports.CreateCompanyDocMapDto = exports.CreateGroupCompanyMapDto = exports.CreateGstDto = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const swagger_1 = require("@nestjs/swagger");
const common_1 = require("@nestjs/common");
const response_utils_1 = require("../../../../../../../libs/service-lib/src/lib/utils/response.utils");
const create_address_dto_1 = require("../../address/dto/create-address.dto");
class CreateGstDto {
}
exports.CreateGstDto = CreateGstDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "State ID", example: 1 }),
    (0, class_validator_1.IsNumber)({}, { message: "State ID must be a valid number." }),
    (0, class_validator_1.IsNotEmpty)({ message: "State ID is required." }),
    tslib_1.__metadata("design:type", Number)
], CreateGstDto.prototype, "stateId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "GST number", example: "22ABCDE1234F1Z5" }),
    (0, class_validator_1.IsString)({ message: "GST number must be a string." }),
    (0, class_validator_1.IsNotEmpty)({ message: "GST number is required." }),
    (0, class_validator_1.Matches)(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/, {
        message: "Invalid GST number format. It should follow the format: 22ABCDE1234F1Z5.",
    }),
    tslib_1.__metadata("design:type", String)
], CreateGstDto.prototype, "gstNumber", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "GST category ID", example: 101 }),
    (0, class_validator_1.IsNumber)({}, { message: "GST category ID must be a valid number." }),
    (0, class_validator_1.IsNotEmpty)({ message: "GST category ID is required." }),
    tslib_1.__metadata("design:type", Number)
], CreateGstDto.prototype, "gstCategoryLid", void 0);
class CreateGroupCompanyMapDto {
}
exports.CreateGroupCompanyMapDto = CreateGroupCompanyMapDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Group Company ID", example: 2 }),
    (0, class_validator_1.IsNumber)({}, { message: "Group Company ID must be a valid number." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Group Company ID is required." }),
    tslib_1.__metadata("design:type", Number)
], CreateGroupCompanyMapDto.prototype, "groupCompanyId", void 0);
class CreateCompanyDocMapDto {
}
exports.CreateCompanyDocMapDto = CreateCompanyDocMapDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Document ID", example: 101 }),
    (0, class_validator_1.IsNumber)({}, { message: "Document ID must be a valid number." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Document ID is required." }),
    tslib_1.__metadata("design:type", Number)
], CreateCompanyDocMapDto.prototype, "documentId", void 0);
class CreateCompanyDto {
}
exports.CreateCompanyDto = CreateCompanyDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Name of the company",
        example: "Tech Solutions Inc.",
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Company name is required." }),
    (0, class_validator_1.IsString)({ message: "Company name must be a string." }),
    (0, class_validator_1.MinLength)(3, { message: "Company name must be at least 3 characters long." }),
    (0, class_validator_1.MaxLength)(200, { message: "Company name must not exceed 200 characters." }),
    (0, class_transformer_1.Transform)(({ value }) => (value ? value.trim() : value)),
    tslib_1.__metadata("design:type", String)
], CreateCompanyDto.prototype, "companyName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Display name of the company",
        example: "Tech Solutions",
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Display name is required." }),
    (0, class_validator_1.IsString)({ message: "Display name must be a string." }),
    (0, class_validator_1.MinLength)(3, { message: "Display name must be at least 3 characters long." }),
    (0, class_validator_1.MaxLength)(100, { message: "Display name must not exceed 100 characters." }),
    (0, class_transformer_1.Transform)(({ value }) => (value ? value.trim() : value)),
    tslib_1.__metadata("design:type", String)
], CreateCompanyDto.prototype, "displayName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Company type ID", example: 20 }),
    (0, class_validator_1.IsNotEmpty)({ message: "Company type id is required." }),
    (0, class_validator_1.IsInt)({ message: "Company type id must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateCompanyDto.prototype, "companyTypeLid", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Currency id must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateCompanyDto.prototype, "currencyId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Industry segment ID", example: 191 }),
    (0, class_validator_1.IsNotEmpty)({ message: "Industry segment id is required." }),
    (0, class_validator_1.IsInt)({ message: "Industry segment id must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateCompanyDto.prototype, "industrySegmentLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Group company lid", example: 48 }),
    (0, class_validator_1.IsNotEmpty)({ message: "Group company Lid is required." }),
    (0, class_validator_1.IsInt)({ message: "Group company Lid must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateCompanyDto.prototype, "groupCompanyLid", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", String)
], CreateCompanyDto.prototype, "existingBrokerName", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", String)
], CreateCompanyDto.prototype, "insurerName", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", String)
], CreateCompanyDto.prototype, "tpaName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Number of employees",
        example: 500,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Number of employees must be a valid number." }),
    (0, class_validator_1.Min)(0, { message: "Number of employees must be a positive number." }),
    tslib_1.__metadata("design:type", Number)
], CreateCompanyDto.prototype, "noOfEmployees", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Date of incorporation",
        example: "2020-01-15",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Date of incorporation must be a string." }),
    (0, class_transformer_1.Transform)(({ value }) => value ? value.trim() : value),
    (0, class_validator_1.Matches)(/^\d{4}-\d{2}-\d{2}$/, {
        message: "Date of incorporation must be in the format YYYY-MM-DD.",
    }),
    (0, class_transformer_1.Transform)(({ value }) => {
        const date = new Date(value);
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Reset time to start of the day
        if (date >= today) {
            throw new common_1.BadRequestException("The date of incorporation cannot be today or a future date. Please provide a valid past date.");
        }
        return value;
    }),
    tslib_1.__metadata("design:type", String)
], CreateCompanyDto.prototype, "dateOfIncorporation", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "PAN card number",
        example: "ABCDE1234F",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "PAN card number must be a string." }),
    (0, class_validator_1.Matches)(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, {
        message: "Invalid PAN format. It should be in the format ABCDE1234F.",
    }),
    tslib_1.__metadata("design:type", String)
], CreateCompanyDto.prototype, "panCardNumber", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Registration number",
        example: "L98765DL1999PLC987654",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Registration number must be a string." }),
    (0, class_validator_1.Matches)(/^[UL]\d{5}[A-Z]{2}\d{4}[A-Z]{3}\d{6}$/, {
        message: "Invalid registration number. It should be in the format L98765DL1999PLC987654.",
    }),
    (0, class_transformer_1.Transform)(({ value }) => value ? value.trim() : value),
    tslib_1.__metadata("design:type", String)
], CreateCompanyDto.prototype, "registrationNo", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ description: "Annual premium", example: 1000000 }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { message: "Annual premium must be a valid number." }),
    (0, class_validator_1.Min)(0, { message: "Annual premium must be a positive number." }),
    tslib_1.__metadata("design:type", Number)
], CreateCompanyDto.prototype, "annualPremium", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "TAN number",
        example: "ABCD12345E",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "TAN number must be a string." }),
    (0, class_validator_1.Matches)(/^[A-Z]{4}[0-9]{5}[A-Z]{1}$/, {
        message: "Invalid TAN format. It should be in the format ABCD12345E.",
    }),
    tslib_1.__metadata("design:type", String)
], CreateCompanyDto.prototype, "tanNumber", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Website URL",
        example: "https://www.techsolutions.com",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Website must be a string." }),
    (0, class_validator_1.IsUrl)({}, { message: "Website must be a valid URL." }),
    (0, class_transformer_1.Transform)(({ value }) => {
        value = value ? value.trim() : value;
        return value?.length === 0 ? null : value;
    }),
    tslib_1.__metadata("design:type", String)
], CreateCompanyDto.prototype, "website", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Remarks",
        example: "Strong potential for growth in the next 5 years.",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Remarks must be a string." }),
    (0, class_transformer_1.Transform)(({ value }) => {
        const cleanedValue = value ? (0, response_utils_1.removeHtmlTags)(value) : value;
        if (cleanedValue && cleanedValue.length > 500) {
            throw new common_1.BadRequestException("remarks reason must not exceed 500 characters");
        }
        return value?.length === 0 ? null : value;
    }),
    tslib_1.__metadata("design:type", String)
], CreateCompanyDto.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ description: "Source Type", example: 2 }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Source type must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateCompanyDto.prototype, "sourceTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ description: "Source", example: "Internal" }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Source must be a string." }),
    (0, class_transformer_1.Transform)(({ value }) => {
        const cleanedValue = value ? (0, response_utils_1.removeHtmlTags)(value) : value;
        if (cleanedValue && cleanedValue.length > 100) {
            throw new common_1.BadRequestException("source reason must not exceed 100 characters");
        }
        return value?.length === 0 ? null : value;
    }),
    tslib_1.__metadata("design:type", String)
], CreateCompanyDto.prototype, "source", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Priority ID", example: 1 }),
    (0, class_validator_1.IsNotEmpty)({ message: "Priority ID is required." }),
    (0, class_validator_1.IsInt)({ message: "Priority ID must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateCompanyDto.prototype, "priorityLid", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Status ID must be an integer." }),
    tslib_1.__metadata("design:type", Number)
], CreateCompanyDto.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ description: "LeadCRM", example: 2 }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "LeadCRM must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateCompanyDto.prototype, "leadCrm", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ description: "Account Manager", example: 4 }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Account manager must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateCompanyDto.prototype, "accountManager", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Country id must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateCompanyDto.prototype, "countryId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Sentiment ID",
        type: Number,
        example: 1,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Sentiment id must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateCompanyDto.prototype, "sentimentLid", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CreateCompanyDto.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CreateCompanyDto.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "GST details",
        type: [CreateGstDto],
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => CreateGstDto),
    tslib_1.__metadata("design:type", Array)
], CreateCompanyDto.prototype, "gstDetails", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Group Company Maps",
        type: CreateGroupCompanyMapDto,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => CreateGroupCompanyMapDto),
    tslib_1.__metadata("design:type", CreateGroupCompanyMapDto)
], CreateCompanyDto.prototype, "groupCompanyMap", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Company Document Maps",
        type: [CreateCompanyDocMapDto],
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => CreateCompanyDocMapDto),
    tslib_1.__metadata("design:type", Array)
], CreateCompanyDto.prototype, "companyDocMaps", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Company Address",
        type: [create_address_dto_1.CreateAddressDto],
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Company address is required." }),
    (0, class_validator_1.IsArray)({ message: "Company address must be an array." }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => create_address_dto_1.CreateAddressDto),
    tslib_1.__metadata("design:type", Array)
], CreateCompanyDto.prototype, "addresses", void 0);
